import { DatePicker } from "@mui/x-date-pickers/DatePicker";
import { LocalizationProvider } from "@mui/x-date-pickers/LocalizationProvider";
import { AdapterDateFns } from "@mui/x-date-pickers/AdapterDateFns";
import enGB from "date-fns/locale/en-GB";
import { Box } from "@mui/material";
import { parseISO, isValid } from "date-fns";

const toPickerDate = (value) => {
  if (!value) return null;

  const parsed = parseISO(value);
  return isValid(parsed) ? parsed : null;
};

const DateInput = ({ label, name, value, setFieldValue, error, touched }) => {
  return (
    <Box sx={{ width: "25%", minWidth: 150 }}>
      <LocalizationProvider dateAdapter={AdapterDateFns} adapterLocale={enGB}>
        <DatePicker
          label={label}
          format="dd-MM-yyyy"
          value={toPickerDate(value)}
          onChange={(date) => {
            setFieldValue(name, date ? date.toISOString() : null);
          }}
          slotProps={{
            textField: {
              variant: "filled",
              fullWidth: true,
              name,
              error: touched && !!error,
              helperText: touched && error,
              InputLabelProps: { shrink: true },
              sx: {
                svg: { color: "#fff" },
              },
            },
          }}
        />
      </LocalizationProvider>
    </Box>
  );
};

export default DateInput;